import { FC } from "react";
import { Box, Button, Stack } from "@mui/material";
import { StepLayoutContainer } from "components/Layout/StepLayoutContainer";
import { ReportAlert } from "../../UploadCSVUsers/components";
import { ImportReport } from "../types";

type Props = {
  report: ImportReport;
  onFinish: () => void;
};

export const CompleteStep: FC<Props> = ({ report, onFinish }) => {
  return (
    <StepLayoutContainer
      title="Import complete"
      renderActionButtons={
        <Button variant="contained" color="primary" onClick={onFinish} fullWidth>
          Back to list
        </Button>
      }
    >
      <Stack spacing={2} mt={2}>
        {report.success.length > 0 && (
          <ReportAlert
            report={report.success}
            severity="success"
            textDescription="Requirements imported successfully"
          />
        )}
        {report.renamed.length > 0 && (
          <ReportAlert
            report={report.renamed}
            severity="warning"
            textDescription="Requirements renamed due to duplicate names"
          />
        )}
        {report.missingLinks.length > 0 && (
          <ReportAlert
            report={report.missingLinks}
            severity="warning"
            textDescription="Some links were skipped"
          />
        )}
        {report.error.length > 0 && (
          <ReportAlert
            report={report.error}
            severity="error"
            textDescription="Requirements failed to import"
          />
        )}
      </Stack>
      <Box mt={2} />
    </StepLayoutContainer>
  );
};
